import { webCoreTypes } from "@core/core-types.di";
import { FallbackError } from "@core/domain/errors/fallback.error";
import type { IotApiClient } from "@iot-platform/core";
import type { PestsDto } from "@station/data/dto/pest.dto";
import { PestMapper } from "@station/data/mappers/pest.mapper";
import type { Pests } from "@station/domain/models/pest.model";
import { inject, injectable } from "inversify";
import type { ResultAsync } from "neverthrow";

@injectable()
export class PestDatasource {
    static readonly PESTS_PATH = "/stations/:stationId/agent_risks";

    constructor(
        @inject(webCoreTypes.infrastructure.IotApiClient)
        private readonly iotApiClient: IotApiClient,
        @inject(PestMapper)
        private readonly pestMapper: PestMapper,
    ) {}

    fetchAllPest(stationId: string): ResultAsync<Pests, FallbackError> {
        return this.iotApiClient.http
            .get<PestsDto>(
                PestDatasource.PESTS_PATH.replace(":stationId", stationId),
            )
            .mapErr(() => new FallbackError())
            .map((response) => this.pestMapper.mapList(response.data));
    }
}
